"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.spline = exports.Spline = void 0;
var leaflet_1 = __importDefault(require("leaflet"));
require("@elfalem/leaflet-curve");
/**
 * Get line length and bearing
 */
var line = function (coord1, coord2) {
    var lengthX = coord2.x - coord1.x;
    var lengthY = coord2.y - coord1.y;
    return {
        length: Math.sqrt(Math.pow(lengthX, 2) + Math.pow(lengthY, 2)),
        angle: Math.atan2(lengthY, lengthX)
    };
};
/**
 * Gets 2 cubic bezier control points given a current, previous, and next point
 */
var controlPoint = function (smoothing, map, current, previous, next, reverse) {
    /**
     * When current is the first or last point of the array, prev and next
     * dont exist.  Replace with current
     */
    var p = previous || current;
    var n = next || current;
    var currPoint = map.latLngToLayerPoint(leaflet_1["default"].latLng(current));
    var prevPoint = map.latLngToLayerPoint(leaflet_1["default"].latLng(p));
    var nextPoint = map.latLngToLayerPoint(leaflet_1["default"].latLng(n));
    var _a = line(prevPoint, nextPoint), length = _a.length, angle = _a.angle;
    angle = angle + (reverse ? Math.PI : 0);
    length = length * smoothing;
    var x = currPoint.x + Math.cos(angle) * length;
    var y = currPoint.y + Math.sin(angle) * length;
    var _b = map.layerPointToLatLng([x, y]), lat = _b.lat, lng = _b.lng;
    return [lat, lng];
};
var Spline = /** @class */ (function (_super) {
    __extends(Spline, _super);
    function Spline(path, options) {
        var _a;
        var _this = _super.call(this, path, options) || this;
        _this._points = [];
        _this._curve = new leaflet_1["default"].Curve([], __assign({}, options));
        _this._smoothing = (_a = options.smoothing) !== null && _a !== void 0 ? _a : 0.15;
        _this._transformPoints(path);
        return _this;
    }
    /**
     * Transforms points into proper format for leaflet.curve (must be in [lat, lng] format)
     */
    Spline.prototype._transformPoints = function (path) {
        if (Array.isArray(path[0]) && path[0].length === 2) {
            // If path given is array of array of numbers, it is already in proper format
            this._points = path;
        }
        else if (path[0].lat) {
            // If path is given as latlngs, transform into Tuple / [number, number] format for
            this._points = path.map(function (latlng) { return [
                latlng.lat,
                latlng.lng,
            ]; });
        }
    };
    Spline.prototype.drawBezier = function () {
        /**
         * Check to make sure there is a map already attached to spline option,
         * required for controlPoint function, which requires map projection functions
         */
        if (this._map) {
            var points = __spreadArray([], this._points, true);
            var first = __spreadArray([], points[0], true);
            /** points.length */
            var pl = points.length;
            /** Whether or not the path given is a closed shape - last point must be same as first */
            var isClosedShape = points[0][0] === points[pl - 1][0] &&
                points[0][1] === points[pl - 1][1];
            var controlPoints = [];
            for (var i = 0; i < pl - 1; i++) {
                controlPoints.push(controlPoint(this._smoothing, this._map, points[i], points[i + 1], points[i - 1]));
                controlPoints.push(controlPoint(this._smoothing, this._map, points[i], points[i - 1], points[i + 1]));
            }
            if (!isClosedShape) {
                /* Remove first (and last) control points for open shapes */
                controlPoints.shift();
                /* Push one last control point just before the last reference point, has no 'next' */
                controlPoints.push(controlPoint(this._smoothing, this._map, points[pl - 1], undefined, points[pl - 2]));
            }
            else {
                /* Shift points */
                var firstCp = controlPoints.shift();
                controlPoints.push(firstCp);
                /* Recalculate first cp with last point in points as previous */
                controlPoints[0] = controlPoint(this._smoothing, this._map, points[pl - 1], points[pl - 2], points[1]);
                controlPoints[controlPoints.length - 1] = controlPoint(this._smoothing, this._map, points[pl - 1], points[1], points[pl - 2]);
            }
            /** Series of SVG commands mixed with coordinates to be used with L.curve */
            var commands = ["M", first]; // Begin with placing pen at first point
            points = __spreadArray([], this._points, true);
            var lineTo = points.shift();
            commands.push.apply(commands, ["L", lineTo]); // draw line to first point (its a dot), helpful for dev
            while (points.length > 0) {
                var cp1 = controlPoints.shift();
                var cp2 = controlPoints.shift();
                var destination = points.shift();
                commands.push.apply(commands, ["C", cp1, cp2, destination]);
            }
            if (isClosedShape) {
                commands.push("Z"); // Complete the drawing
            }
            if (!this._curve) {
                this._curve = leaflet_1["default"].curve(commands, __assign({}, this.options));
            }
            else {
                this._curve.setPath(commands);
            }
        }
        return this._curve;
    };
    /**
     * Redraw bezier on update
     */
    Spline.prototype.update = function () {
        this.drawBezier();
    };
    Spline.prototype.onAdd = function (map) {
        var _this = this;
        this.drawBezier();
        this._curve.addTo(map);
        map.on("zoomend", function () {
            _this.update();
        });
        return this;
    };
    Spline.prototype.onRemove = function (map) {
        var _this = this;
        map.off("zoomend", function () {
            _this.update();
        });
        this._curve.remove();
        return this;
    };
    /* -------- Forward methods to this._curve -------- */
    /* Events from L.Evented */
    Spline.prototype.on = function (type, fn, context) {
        this._curve.on(type, fn, context);
        return this;
    };
    Spline.prototype.off = function (type, fn, context) {
        this._curve.off(type, fn, context);
        return this;
    };
    Spline.prototype.once = function (type, fn, context) {
        this._curve.once(type, fn, context);
        return this;
    };
    Spline.prototype.fire = function (type, data, propagate) {
        this._curve.once(type, data, propagate);
        return this;
    };
    Spline.prototype.listens = function (type) {
        return this._curve.listens(type);
    };
    Spline.prototype.addEventParent = function (obj) {
        this._curve.addEventParent(obj);
        return this;
    };
    Spline.prototype.removeEventParent = function (obj) {
        this._curve.removeEventParent(obj);
        return this;
    };
    Spline.prototype.addEventListener = function (type, fn, context) {
        this._curve.addEventListener(type, fn, context);
        return this;
    };
    Spline.prototype.removeEventListener = function (type, fn, context) {
        this._curve.removeEventListener(type, fn, context);
        return this;
    };
    Spline.prototype.clearAllEventListeners = function () {
        this._curve.clearAllEventListeners();
        return this;
    };
    Spline.prototype.fireEvent = function (type, data, propagate) {
        this._curve.fireEvent(type, data, propagate);
        return this;
    };
    Spline.prototype.hasEventListeners = function (type) {
        return this._curve.hasEventListeners(type);
    };
    /* Layer methods from L.Layer */
    Spline.prototype.remove = function () {
        this._curve.remove();
        return this;
    };
    Spline.prototype.removeFrom = function (map) {
        this._curve.removeFrom(map);
        return this;
    };
    Spline.prototype.getPane = function (name) {
        return this._curve.getPane(name);
    };
    Spline.prototype.bindPopup = function (content, options) {
        console.log(options);
        this._curve.bindPopup(content, options);
        return this;
    };
    Spline.prototype.unbindPopup = function () {
        this._curve.unbindPopup();
        return this;
    };
    Spline.prototype.openPopup = function (latlng) {
        this._curve.openPopup(latlng);
        return this;
    };
    Spline.prototype.closePopup = function () {
        this._curve.closePopup();
        return this;
    };
    Spline.prototype.togglePopup = function () {
        this._curve.togglePopup();
        return this;
    };
    Spline.prototype.isPopupOpen = function () {
        return this._curve.isPopupOpen();
    };
    Spline.prototype.setPopupContent = function (content) {
        this._curve.setPopupContent(content);
        return this;
    };
    Spline.prototype.getPopup = function () {
        return this._curve.getPopup();
    };
    Spline.prototype.bindTooltip = function (content, options) {
        this._curve.bindTooltip(content, options);
        return this;
    };
    Spline.prototype.unbindTooltip = function () {
        this._curve.unbindTooltip();
        return this;
    };
    Spline.prototype.openTooltip = function (latlng) {
        this._curve.openTooltip(latlng);
        return this;
    };
    Spline.prototype.closeTooltip = function () {
        this._curve.closeTooltip();
        return this;
    };
    Spline.prototype.toggleTooltip = function () {
        this._curve.toggleTooltip();
        return this;
    };
    Spline.prototype.isTooltipOpen = function () {
        return this._curve.isTooltipOpen();
    };
    Spline.prototype.setTooltipContent = function (content) {
        this._curve.setTooltipContent(content);
        return this;
    };
    Spline.prototype.getTooltip = function () {
        return this._curve.getTooltip();
    };
    /* Path methods from L.Path */
    Spline.prototype.redraw = function () {
        this._curve.redraw();
        return this;
    };
    Spline.prototype.setStyle = function (style) {
        leaflet_1["default"].Util.setOptions(this, style);
        this._curve.setStyle(style);
        return this;
    };
    Spline.prototype.bringToFront = function () {
        this._curve.bringToFront();
        return this;
    };
    Spline.prototype.bringToBack = function () {
        this._curve.bringToBack();
        return this;
    };
    Spline.prototype.getElement = function () {
        return this._curve.getElement();
    };
    /* Polyline methods from L.Polyline */
    Spline.prototype.setLatLngs = function (latlngs) {
        this._transformPoints(latlngs);
        this.drawBezier();
        return this;
    };
    /* Curve methods from L.Curve */
    Spline.prototype.trace = function (samplingDistance) {
        return this._curve.trace(samplingDistance);
    };
    return Spline;
}(leaflet_1["default"].Polyline));
exports.Spline = Spline;
function spline(path, options) {
    if (options === void 0) { options = {}; }
    return new Spline(path, options);
}
exports.spline = spline;
leaflet_1["default"].Spline = Spline;
leaflet_1["default"].spline = spline;
//# sourceMappingURL=index.js.map